module.exports = __webpack_public_path__ + "static/img/tongyong.d3ae680e.png";